export default "__VITE_ASSET__4f871921__"